// src/components/navbar/ItemLink.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaFileAlt } from "react-icons/fa";

const ItemLink = ({ item, closeMenu }) => {
  const Icon = item.icon || FaFileAlt;

  return (
    <li>
      <Link
        to={item.to}
        onClick={closeMenu}
        className="flex flex-row-reverse items-center gap-2 px-3 py-2 text-xs sm:text-[0.8rem]
          text-slate-100 hover:text-slate-50
          hover:bg-slate-800/80 rounded-xl transition-colors"
      >
        <span className="flex items-center justify-center w-6 h-6 rounded-lg bg-slate-900/70">
          <Icon className="text-[0.7rem]" />
        </span>
        <span className="truncate">{item.label}</span>
      </Link>
    </li>
  );
};

export default ItemLink;
